import { Injectable } from '@angular/core';
import { MvpHttpClient } from "../../../mvp-auth";
import { DmsAvailableSignaturesResponseSchema } from '../../model/dmsAvailableSignaturesResponseSchema';

@Injectable({
  providedIn: 'root'
})
export class AvailableSignaturesService {

  constructor(private readonly http: MvpHttpClient) { }

  getAvailableSignatures$(){
    return this.http.get<any>(`/dms/signature/availableSignatures`);
  }
}
